<!--- Formulario FrmWorkerRecords ---->
<!---
Descripción del componente y comportamiento:
---------------------------
-

Eventos escuchados por el formulario:
-----------------------

Eventos generados por el formulario:
-----------------------
-  XXXXXXX ->
--->

<template>
  <f7-page>
    <template #fixed>
      <TheNavbar
        nav-title="Resumen Actividad trabajador"
        back-btn-enable
      />
    </template>

    <div>
      <f7-block class="no-margin padding no-padding-top bg-lightsnow">
        <!-- Datos Trabajador Seleccionado -->
        <div class="div-cabeceraDatosTrabajador">
          <PCWorkerPresenceCard
            v-if="selectedWorker != null"
            :selected-worker="selectedWorker"
          />
        </div>
        <UCDatePicker
          id="1"
          title="Fecha consulta"
          @onchange="ValorFechaModificado"
        />
      </f7-block>
      <f7-block class="no-margin no-padding bg-white padding-left">
        <PCActivityWorker
          ref="componentPCActivityWorker"
          :selected-worker="selectedWorker"
        />
      </f7-block>
    </div>
  </f7-page>
</template>

<script>
import { mapState } from 'pinia';
import { usePresenceStore } from '@/js/stores/presence';

import TheNavbar from '@/components/TheNavbar.vue';
import { Log } from '@/js/common/HIDebuggingSupport';
import UCDatePicker from '@/components/common/UCDatePicker.vue';
import PCWorkerPresenceCard from '@/components/presence/workerRecords/PCWorkerPresenceCard.vue';
import PCActivityWorker from '@/components/presence/workerRecords/PCActivityWorker.vue';

export default {
  name: 'FrmWorkerRecordsSearch',
  components: {
    UCDatePicker,
    PCWorkerPresenceCard,
    PCActivityWorker,
    TheNavbar,
  },

  data() {
    return {
      dateOfQuery: null,
    };
  },
  computed: {
    ...mapState(usePresenceStore, ['selectedWorker']),
  },

  mounted() {
    this.StartForm();
  },

  methods: {
    StartForm() {
      Log(this, this.StartForm.name);
      this.dateOfQuery = new Date();
      this.$refs.componentPCActivityWorker.UpdateRecordsByActivityGroup(this.dateOfQuery);
    },

    ValorFechaModificado(value) {
      Log(this, this.ValorFechaModificado.name);
      this.dateOfQuery = value;
      this.$refs.componentPCActivityWorker.UpdateRecordsByActivityGroup(this.dateOfQuery);
    },
  },
};
</script>
